import ConnectionsPage from "./components/Connections/ConnectionsPage";

const LinkedinCallback = () => <ConnectionsPage callbackPlatform="linkedin" />;

export default LinkedinCallback;
